import cookies from '../helpers/cookies';

const $modal = $('#autoOpenModal');
const $button = $('.js-auto-open-modal-button');

export default {
  /**
   * Loop through elements, and create event listeners for every element
   * @return {Void}
   */
  initialize() {
    if (!$modal.length) {
      return;
    }

    if ($modal.hasClass('ab-test')) {
      return;
    }

    $button.on('click', () => {
      cookies.set('auto-open-modal', '1', 365);
    });

    $modal.on('hide.bs.modal', () => {
      cookies.set('auto-open-modal', '1', 365);
    });
  },
};
